// extracted by mini-css-extract-plugin
export var contained = "icon-module--contained--7417f";
export var containerIcon = "icon-module--containerIcon--5e3c6";
export var icon = "icon-module--icon--44dd4";